export function getActiveChartTypeOption(currentChartType, options) {
  const currentChartTypeOptionIdx = options.findIndex(option => option.value === currentChartType);
  const currentChartTypeOption = options[currentChartTypeOptionIdx];
  return {
    currentChartTypeOption,
    currentChartTypeOptionIdx
  };
}